// src/services/customerService.js
// Ortak müşteri işlemleri servisi

import { db } from '../firebase';
import { collection, addDoc, updateDoc, doc, Timestamp } from 'firebase/firestore';

/**
 * Yeni müşteri oluştur
 * @param {Object} customerData - Müşteri bilgileri
 * @returns {Promise<string>} - Oluşturulan müşteri ID'si
 */
export const createCustomer = async (customerData) => {
    try {
        const docRef = await addDoc(collection(db, 'customers'), {
            ...customerData,
            bakiye: 0, // Varsayılan bakiye
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now()
        });
        return docRef.id;
    } catch (error) {
        console.error('Müşteri oluşturulurken hata:', error);
        throw new Error(`Müşteri oluşturulamadı: ${error.message}`);
    }
};

/**
 * Mevcut müşteriyi güncelle
 * @param {string} customerId - Müşteri ID'si
 * @param {Object} customerData - Güncellenecek müşteri bilgileri
 */
export const updateCustomer = async (customerId, customerData) => {
    try {
        await updateDoc(doc(db, 'customers', customerId), {
            ...customerData,
            updatedAt: Timestamp.now()
        });
    } catch (error) {
        console.error('Müşteri güncellenirken hata:', error);
        throw new Error(`Müşteri güncellenemedi: ${error.message}`);
    }
};
